import { Form } from "common/Forms"
import { TableRenderer } from "common/Table"
import { Link } from 'react-router-dom';
import { convertDateToLocaleDateString } from "Constant/utils"
import { IoLinkSharp } from "react-icons/io5";

export const TableView = ({ list }) => {
  return (
    <Form>
      <TableRenderer
        data={list ?? []}
        columns={
          [
            {
              name: 'Site ID',
              bodyRenderer: x => x?.siteid
            },
            {
              name: 'Status',
              bodyRenderer: x => x?.status ? x.status.charAt(0).toUpperCase() + x.status.slice(1) : <div style={{ textAlign: 'center' }}>-</div>
            },
            {
              name: 'Ordering Options',
              bodyRenderer: x => x?.optionDetail?.name
            },
            {
              name: 'Order Id',
              bodyRenderer: x => x?._id
            },
            {
              name: 'Total Price',
              bodyRenderer: x => `${x?.totalPrice || '-'} ${x?.currency ? `(${x?.currency?.toUpperCase()})` : ''}`
            },
            {
              name: 'Order Create Date',
              bodyRenderer: x => convertDateToLocaleDateString(new Date(x?.createdAt))
            },
            {
              name: 'Receipt',
              bodyRenderer: x =>
                x?.paymentReceipt ?
                <Link to={x.paymentReceipt} target="_blank" ><IoLinkSharp color="#7aa8a8" size={25}/></Link> : '-'
            },
          ]
        }
      />
    </Form>
  )
}